import { useEffect } from 'react';

interface ToastProps {
  message: string;
  icon?: string;   // FA icon class suffix
  onDismiss: () => void;
  duration?: number; // ms, default 3000
}

export function Toast({ message, icon = 'circle-check', onDismiss, duration = 3000 }: ToastProps) {
  useEffect(() => {
    const id = setTimeout(onDismiss, duration);
    return () => clearTimeout(id);
  }, [onDismiss, duration]);

  return (
    <div className="escape-toast" role="status" aria-live="polite">
      <i className={`fa-solid fa-${icon}`} aria-hidden="true" />
      <span>{message}</span>
      <button
        className="escape-toast__close"
        type="button"
        aria-label="Dismiss"
        onClick={onDismiss}
      >
        <i className="fa-solid fa-xmark" aria-hidden="true" />
      </button>
    </div>
  );
}
